export const addAccountsToOrganizationBulkActionType = 'addAccountsToOrganization';
